var _path, _ellipse, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShopping1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M621 472L621 500",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 621.5,
    cy: 467.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M618.105 476C617.637 476 617.236 475.834 616.903 475.501C616.57 475.168 616.403 474.767 616.403 474.3C616.403 473.833 616.57 473.432 616.903 473.099C617.236 472.766 617.637 472.6 618.105 472.6C618.573 472.6 618.973 472.766 619.306 473.099C619.64 473.432 619.806 473.833 619.806 474.3C619.806 474.767 619.64 475.168 619.306 475.501C618.973 475.834 618.573 476 618.105 476ZM626.613 476C626.145 476 625.744 475.834 625.411 475.501C625.078 475.168 624.911 474.767 624.911 474.3C624.911 473.833 625.078 473.432 625.411 473.099C625.744 472.766 626.145 472.6 626.613 472.6C627.081 472.6 627.481 472.766 627.814 473.099C628.148 473.432 628.314 473.833 628.314 474.3C628.314 474.767 628.148 475.168 627.814 475.501C627.481 475.834 627.081 476 626.613 476ZM617.382 462.4L619.423 466.65H625.379L627.719 462.4H617.382ZM616.573 460.7H629.122C629.449 460.7 629.697 460.845 629.867 461.136C630.037 461.426 630.044 461.72 629.888 462.018L626.868 467.457C626.712 467.741 626.503 467.96 626.24 468.116C625.978 468.272 625.691 468.35 625.379 468.35H619.041L618.105 470.05H628.314V471.75H618.105C617.467 471.75 616.985 471.47 616.658 470.911C616.332 470.351 616.318 469.795 616.616 469.243L617.764 467.16L614.702 460.7H613V459H615.765L616.573 460.7Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping1);
export default __webpack_public_path__ + "static/media/shopping_1.605054ab40cb79c0a8f8509545ef0622.svg";
export { ForwardRef as ReactComponent };